import React, { useState } from "react";
import { generateresponse } from "../AI_Call/GeminiAI"; 

const ParaphrasingTool = ({ darkMode }) => {
  const [text, setText] = useState("");
  const [paraphrasedText, setParaphrasedText] = useState("");
  const [activeMode, setActiveMode] = useState("Standard");
  const [loading, setLoading] = useState(false);

  const styles = {
    container: {
      fontFamily: "Arial, sans-serif",
      backgroundColor: darkMode ? "#333" : "#f9f9f9",
      color: darkMode ? "#fff" : "#000",
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      paddingTop: "40px",
      transition: "background-color 0.3s ease, color 0.3s ease",
    },
    toolbar: {
      backgroundColor: darkMode ? "#444" : "#fff",
      color: darkMode ? "#fff" : "#000",
      width: "100%",
      padding: "10px 0px",
      borderBottom: darkMode ? "1px solid #555" : "1px solid #ddd",
      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
    },
    modes: {
      display: "flex",
      gap: "15px",
      justifyContent: "center",
      fontFamily: "'Arial', sans-serif",
    },
    mode: {
      padding: "8px 12px",
      cursor: "pointer",
      fontSize: "1rem",
      color: darkMode ? "#ddd" : "#555",
      borderRadius: "5px",
      transition: "all 0.3s ease",
      outline: "none",
      fontWeight: "bold",
    },
    activeMode: {
      backgroundColor: "#2ECC71",
      fontWeight: "bold",
    },
    content: {
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
      maxWidth: "1200px",
      marginTop: "20px",
      backgroundColor: darkMode ? "#444" : "#fff",
      color: darkMode ? "#fff" : "#000",
      padding: "20px",
      borderRadius: "8px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    },
    leftPanel: {
      flex: 3,
      display: "flex",
      flexDirection: "column",
      gap: "20px",
    },
    textarea: {
      width: "96%",
      height: "400px",
      fontSize: "16px",
      padding: "10px",
      border: darkMode ? "1px solid #555" : "1px solid #ddd",
      borderRadius: "5px",
      backgroundColor: darkMode ? "#555" : "#fff",
      color: darkMode ? "#fff" : "#000",
      resize: "none",
    },
    rightPanel: {
      flex: 3,
      display: "flex",
      flexDirection: "column",
      gap: "20px",
    },
    paraphraseButton: {
      padding: "15px 30px",
      fontSize: "18px",
      fontWeight: "bold",
      backgroundColor: darkMode ? "#2ECC71" : "green",
      color: "white",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
      transition: "background-color 0.3s",
      outline: "none",
    },
  };

  const modes = ["Standard", "Fluency", "Natural", "Formal"];

  const handleParaphrase = async () => {
    if (!text.trim()) {
      alert("Please enter text to paraphrase!");
      return;
    }

    setLoading(true);

try {
  const prompt = `Paraphrase this in ${activeMode} mode`;
  const response = await generateresponse(prompt, text);

  console.log("Full API Response:", response); // Log the full response for debugging

  // Extract paraphrased text from the response
  const paraphrasedOutput =
    response.candidates &&
    response.candidates[0] &&
    response.candidates[0].content &&
    response.candidates[0].content.parts &&
    response.candidates[0].content.parts[0] &&
    response.candidates[0].content.parts[0].text
      ? response.candidates[0].content.parts[0].text.trim()
      : "No paraphrased output received.";

  console.log("Extracted Paraphrased Text:", paraphrasedOutput); // Debug the extracted text

    setParaphrasedText(paraphrasedOutput); // Update state with the paraphrased text
  } catch (error) {
    console.error("Error paraphrasing text:", error);
    alert("An error occurred while paraphrasing the text. Please try again.");
  } finally {
    setLoading(false);
  }

  };

  return (
    <div style={styles.container}>
      <header style={styles.toolbar}>
        <div style={styles.modes}>
          {modes.map((mode) => (
            <span
              key={mode}
              style={{
                ...styles.mode,
                ...(activeMode === mode ? styles.activeMode : {}),
              }}
              tabIndex={0}
              role="button"
              aria-label={`Select ${mode} mode`}
              onClick={() => setActiveMode(mode)}
            >
              {mode}
            </span>
          ))}
        </div>
      </header>

      <main style={styles.content}>
        <div style={styles.leftPanel}>
          <textarea
            style={styles.textarea}
            placeholder="Enter your text here..."
            value={text}
            onChange={(e) => setText(e.target.value)}
            aria-label="Input text area"
          />
        </div>
        <div style={styles.rightPanel}>
          <textarea
            style={styles.textarea}
            placeholder="Output will appear here..."
            value={paraphrasedText}
            readOnly
            aria-label="Output text area"
          />
          <button
            style={styles.paraphraseButton}
            onClick={handleParaphrase}
            disabled={loading}
          >
            {loading ? "Paraphrasing..." : "Paraphrase"}
          </button>
        </div>
      </main>
    </div>
  );
};

export default ParaphrasingTool;
